import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "fill-height": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "bg-surface mx-auto px-6 py-6",
        "max-width": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Trocar Senha ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, {
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form) = $event)),
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.usuarioLogado!.nome,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usuarioLogado!.nome) = $event)),
                class: "mb-2",
                clearable: "",
                label: "Usuário",
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.senhaAntiga,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.senhaAntiga) = $event)),
                type: "password",
                rules: [_ctx.required],
                clearable: "",
                label: "Senha Antiga",
                placeholder: "Nova Antiga"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.senha,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.senha) = $event)),
                type: "password",
                rules: [_ctx.required],
                clearable: "",
                label: "Nova Senha",
                placeholder: "Nova Senha"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.confirmar,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmar) = $event)),
                type: "password",
                rules: [_ctx.required],
                clearable: "",
                label: "Confirmar",
                placeholder: "Confirmar Senha"
              }, null, 8, ["modelValue", "rules"]),
              _hoisted_1,
              _createVNode(_component_v_btn, {
                loading: _ctx.loading,
                disabled: !_ctx.form,
                block: "",
                color: "primary",
                size: "large",
                type: "submit",
                variant: "outlined",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_component_v_btn, {
                block: "",
                color: "primary",
                size: "large",
                type: "button",
                variant: "outlined",
                to: "/",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}